import { useState } from "react";
import Objects from "../Utilities/Objects"

function GetObjects() {
    const [objectJson, setObjectsJson] = useState("");

    return <div>
        <h1>Get Available Objects</h1>
        <br></br>
        <h2>Paste the following into the "Execute SOQL Query" method and press run</h2>
        <br></br>
        <p><em>SELECT  QualifiedApiName FROM EntityDefinition order by QualifiedApiName</em></p>
        <br></br>
        <h2>Paste the resulting json into this box and press submit, your file will be downloaded</h2>
        <fieldset>
            <textarea value={objectJson} onChange={(event) => setObjectsJson(event.target.value)}></textarea><br/>
            <Objects data={objectJson}></Objects>
        </fieldset>
    </div>
}

export default GetObjects